<template>
  <div class="app-header" :class="{ 'hidden': isStartpage }">
    <div class="app-header__topbar">
      <div class="app-header__brand">
        <AppLogo class="text-[1.5rem] sm:text-[1.625rem]" />
      </div>
      <div class="app-header__actions">
        <div class="flex items-center gap-4" v-auto-animate>
          <AppNavigationLocation v-if="isCityStart || ['fat'].includes(route.name)" />
          <NuxtLink :to="{ name: 'search' }" class="p-2 -mx-2" v-if="route.name !== 'search'">
            <AtomIcon name="magnifying-glass" />
          </NuxtLink>
          <button class="button-coral text-sm !px-4 !py-1" @click="goToFat" v-if="!isCityStart && !['fat'].includes(route.name)">
            <div class="md:hidden" v-html="$t('shared.book')" />
            <div class="max-md:hidden" v-html="$t('shared.searchTable')" />
          </button>
        </div>
        <button class="border border-sand hover:bg-mist w-8 h-8 rounded flex items-center justify-center duration-300" @click="toggleDrawer()">
          <AtomIcon name="bars" class="relative top-px" />
        </button>
      </div>
    </div>
    <div class="app-header__sidebar">
      <AppNavigation />
    </div>
  </div>
</template>

<script setup>
const app = useAppStore()
const route = useRoute()
const router = useRouter()

// Push FAT route instead of using indexable link
const goToFat = () => {
  router.push({ name: 'fat' })
}

// Toggle drawer with update query
const toggleDrawer = () => {
  useUpdateQuery({ drawer: !route.query?.drawer ? true : undefined })
}

// Check if route is startpage
const isStartpage = computed(() => route.name === 'start')

// Check if route is city start
const isCityStart = computed(() => app.cities?.find(city => '/' + city.slug === route.path))
</script>

<style lang="scss" scoped>
.app-header {
  // @include boxer(cyan, 0, 1);
  @apply sticky top-0 z-40 py-2 px-[4vw] bg-white;

  @screen lg {
    html.startpage & {
      @apply opacity-0 pointer-events-none;
    }
  }
  
  // Tablet
  @apply sm:py-3;

  // Desktop
  @apply lg:fixed lg:top-0 lg:left-0 lg:py-0 lg:px-0 lg:w-64 lg:h-full;
  
  // Widescreen
  @apply 3xl:left-1/2 3xl:-ml-[48rem];

  &__topbar {
    @apply flex items-center justify-between lg:hidden;
  }

  &__brand {
    // 
  }

  &__actions {
    @apply flex items-center gap-4;
    @apply lg:w-full lg:flex-col lg:items-start;
  }

  &__sidebar {
    // @include box(red);
    @apply hidden lg:block;
    @apply py-8 px-8 h-full;
  }
}
</style>